export enum MergedLambdaPdfStatusEnum {
  Pending = 'pending',
  Started = 'started',
  Finished = 'finished',
  Failed = 'failed',
}

export interface MergeResult {
  status: MergedLambdaPdfStatusEnum;
  created_at: string;
  skipped_urls: string[];
  result_file_url: string;
  result_pages: number;
  result_bytes: number;
  started_at: string;
  finished_at: string;
}
